/* Jonathan - Custom JS */
'use strict';

var enableUnitOfMeasure = true; 
var enableAutoOpenProductDetails = true;
var enablehideEmptyDescription = true;
var enableCartShareLinkDeleteCartItem = false;
var enableCartCSR = false;
var enableFilterColors = true;
var enableCardSampleButtonAjax = false; /* still needs testing */
var activeQtyBox = null;

////////////////////////////////////////////////////////////////
// wait for when itoris option fields are ready in the dom
/* function waitForElm(selector, disconnect) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        const observer = new MutationObserver(mutations => { if (document.querySelector(selector)) { resolve(document.querySelector(selector)); if (disconnect === true) observer.disconnect() } });
        observer.observe(document.body, { childList: true, subtree: true, attributes: true, attribute: true })
    })
} */
function waitForElm(s,d=!0){return new Promise(e=>{let t=document.querySelector(s);if(t)return e(t);const o=new MutationObserver(()=>{let t=document.querySelector(s);t&&(d&&o.disconnect(),e(t))});o.observe(document.documentElement,{childList:!0,subtree:!0,attributes:!0,attributeFilter:["class","checked","id","disabled"]})})}

////////////////////////////////////
// 4th of july
/* (function () {

var useSparkle = false;
window.addEventListener('DOMContentLoaded', (event) => {
  if (useSparkle == true) {
    waitForElm('#sparkleCanvas', true).then((elm) => {
      //console.debug('canvas');

      const canvas = document.getElementById('sparkleCanvas');
      // console.debug('canvas',canvas);
      const ctx = canvas.getContext('2d');
      const banner = document.querySelector('.ecs-promo-strip.container');

      let width, height;
      let sparkles = [];

      // Configuration
      const SPARKLE_COUNT = 50;
      const MAX_RADIUS = 5;

      // Resize function now maps to the parent banner container instead of the whole window
      function resize() {
        width = canvas.width = banner.offsetWidth;
        height = canvas.height = banner.offsetHeight;
      }

      window.addEventListener('resize', resize);
      resize();

      class Sparkle {
        constructor() {
          this.reset();
          this.progress = Math.random();
          const isBlue = Math.random() > 0.5;
          this.color = isBlue ? '100, 150, 255' : '255, 255, 255';
        }

        reset() {
          this.x = Math.random() * width;
          this.y = Math.random() * height;
          this.radius = Math.random() * MAX_RADIUS + 2;
          this.speed = Math.random() * 0.005 + 0.005;
          this.progress = 0;
          this.maxOpacity = Math.random() * 0.5 + 0.5;
        }

        update() {
          this.progress += this.speed;
          if (this.progress >= 1) {
            this.reset();
          }
        }

        draw(ctx) {
          const currentOpacity = Math.sin(this.progress * Math.PI) * this.maxOpacity;

          ctx.save();
          ctx.translate(this.x, this.y);

          ctx.beginPath();
          ctx.moveTo(0, -this.radius);
          ctx.quadraticCurveTo(0, 0, this.radius, 0);
          ctx.quadraticCurveTo(0, 0, 0, this.radius);
          ctx.quadraticCurveTo(0, 0, -this.radius, 0);
          ctx.quadraticCurveTo(0, 0, 0, -this.radius);
          ctx.closePath();

          // Sparkle styling
          ctx.fillStyle = `rgba(${this.color}, ${currentOpacity})`;
          ctx.shadowBlur = this.radius;
          ctx.shadowColor = `rgba(${this.color}, ${currentOpacity})`;

          ctx.fill();
          ctx.restore();
        }
      }

      for (let i = 0; i < SPARKLE_COUNT; i++) {
        sparkles.push(new Sparkle());
      }

      function animate() {
        ctx.clearRect(0, 0, width, height);

        sparkles.forEach((sparkle) => {
          sparkle.update();
          sparkle.draw(ctx);
        });

        requestAnimationFrame(animate);
      }

      animate();
    });
  }
});

})(); */
////////////////////////////////////

// JTM - add 4th of july - 4th-of-july
//waitForElm('[data-promo-handle=""newlook"].promo-strip__container', true).then((elm) => {
  /* $q('[data-promo-handle="newlook"].promo-strip__container').wait(true,(elm) => {
    const promoElement = document.querySelector('[data-promo-handle="newlook"].ecs-promo-strip.promo-strip__container');
    if (promoElement) {
      document.documentElement.classList.add('has-promo-4th-july');
    }
  }); */
//});

// top-header-panel
for (var topHeaderPanel of document.querySelectorAll("section.shopify-section-group-header-group #top-panel-header")) {
    $q(topHeaderPanel.closest("section.shopify-section-group-header-group.cc-custom-liquid")).addClass("has-top-panel-header");
}

// use filter colors
if(enableFilterColors == true){
    if(document.querySelector('html.search') != null || document.querySelector('html.is-collections') != null ){
        $q(document.documentElement).addClass("use-filter-colors");
    }
}

//if(document.querySelector(".cc-cart-drawer cart-drawer .cart-empty") !== null){
  //document.body.classList.add("has-empty-cart");
//}

// add html class if product has custom options (itoris)
//waitForElm('html.is-products #itoris_dynamicproductoptions', true).then((elm) => {
$q('html.is-products #itoris_dynamicproductoptions').wait(true,(elm) => {
  //if(document.querySelector("html.is-products .dpo-container") !== null){
     $q(document.documentElement).addClass("has-custom-options");
  //}
});

// listen for add to cart
document.addEventListener('on:cart:add', (event) => {
    if(document.querySelector(".cc-cart-drawer cart-drawer .cart-empty") !== null){
      document.body.classList.add("has-empty-cart");
    }
  
    if(document.querySelector("body.has-empty-cart") !== null){
        document.body.classList.remove("has-empty-cart");
    }
});

////////////////////////////////////////////////
// wait for cat-share-link
if(enableCartShareLinkDeleteCartItem == true){

    function storecartItemVariantID() {

        // remove sessionStorage item 'selectedVariantID'
        sessionStorage.removeItem('selectedVariantID');

        // bind click handler on cart share link 
        document.querySelector('#cart').addEventListener('click', (e) => {

            const link = e.target.closest('.cart-share-link');
            if (!link) return; // not a share link → ignore

            e.preventDefault();

            const parentItem = link.closest('.cart-item');
            const variantID = parentItem?.dataset.variantId;
            if (!variantID) {
                //console.warn('No data-variant-id found for cart item');
                return;
            }

            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('variant', variantID);
            link.href = url.toString();

            // Store variantID in sessionStorage
            //sessionStorage.setItem('selectedVariantID', variantID);
            window.location.href = link.href;
        });
    }

    $q('html.is-cart.q-is-loaded .cart-share-link').wait(true,(elm) => {
        if(document.querySelector('html.is-cart.q-is-loaded .cart-share-link') !== null){
            //sessionStorage.removeItem('selectedVariantID');
            storecartItemVariantID("#cart");
            //console.log("#cart");
         }
     });
        
    $q('html.q-is-loaded #cart-drawer .cart-share-link').wait(true,(elm) => {
         if(document.querySelector('html.q-is-loaded #cart-drawer .cart-share-link') !== null){
            storecartItemVariantID("#cart-drawer-form");
            //console.log("#cart-drawer-form");
         }
    });   
}

//////////////////////////////////
// sample in cart check
document.addEventListener('on:cart:add', (event) => {

  //const t = event.target;
  if(document.querySelector("html.is-products.is-sample-product") !== null){
    sampleProductCartCheck();
  //} else if(t.closest('.has-sample')){
    //sampleProductCartCheck(t);
  } else if(document.querySelector("html.is-products") !== null || document.querySelector("html.is-collections") !== null || document.querySelector("html.search") !== null || document.querySelector("html.is-home") !== null || document.querySelector("html.is-pages") !== null) {
    sampleButtonCartCheck();
    productSampleProductButtonCartCheck();
  }
  if(window.console){ console.log("line-item-add"); }
});

document.addEventListener('on:line-item:change', (event) => {

  if(document.querySelector("html.is-products.is-sample-product") !== null){
    sampleProductCartCheck();
  } else if(document.querySelector("html.is-products") !== null || document.querySelector("html.is-collections") !== null || document.querySelector("html.search") !== null || document.querySelector("html.is-home") !== null || document.querySelector("html.is-pages") !== null) {
    sampleButtonCartCheck();
    productSampleProductButtonCartCheck();
    //resetSampleProductAfterRemoveFromCart();
  }
  if(window.console){ console.log("line-item-change"); }
});

/* $q('#main-content .card.card--product').on('click', function(event){
  
    if(event.target.closest('.has-sample')){
        $q(event.target).addClass("active");
    }
    //if(window.console){ console.log("add active class"); }
}); */

// reference 'activeQtyBox' var for active qty box
// maybe duplicate sampleButtonCartCheck() function
// to make global add tocart for sample products

function sampleButtonCartCheck(){

  setTimeout(function(){
  
    let sampleFormBox = document.querySelector(".sample-form-box");
    if(sampleFormBox !== null && (document.querySelector("html.is-products") !== null || document.querySelector("html.is-collections") !== null || document.querySelector("html.search") !== null || document.querySelector("html.is-home") !== null)){
      
    	let sampleButton = sampleFormBox.querySelector("button.button-sample");
    	let sampleVariantID = sampleFormBox.querySelector(".product-info__add-button-sample").dataset.variantId;
    	let hasSampleInCart = false;
        let sampleCountLimit = false;
        let samplePrice = sampleButton.dataset.samplePrice;
    	let sampleButtonText = "Add " + samplePrice + " Sample";
        let sampleCount = 0;
    	for (var cartItem of document.querySelectorAll("#cart-items tr.cart-item")) {
        	// data-variant-id="46251452170462"
            let productTitle = cartItem.querySelector('.cart-item__title').textContent;
            if(productTitle.indexOf("Sample of") != -1){
              sampleCount++;
            }
        	let variantID = cartItem.dataset.variantId;
    		if(sampleVariantID == variantID){
    			hasSampleInCart = true;
    			sampleButtonText = "Sample in Cart";
    		}
            if(sampleCount == 10){
              sampleCountLimit = true;
            }
    	}
        //console.log("sampleCount",sampleCount);
        //console.log("sampleCountLimit",sampleCountLimit);
    
    	if(hasSampleInCart == true){
    		sampleButton.setAttribute("disabled",true);
    	} else {
    		sampleButton.removeAttribute("disabled");
    	}

        if (sampleCountLimit == true){
          sampleButtonText = "Max Limit of 10 Samples in Cart";
          sampleButton.setAttribute("disabled",true);
        }
          
    	sampleButton.textContent = sampleButtonText;  
    }

  }, 1000);
}

// add active class when last cliocked for adding to cart on card
$q('.card__quick-add button.btn.btn--primary.has-sample').on("mousedown", function(event){

    event.stopPropagation();
    //console.log('this', this);
    //console.log('event.target',event.target);
    $q(".active-sample").removeClass("active-sample");
    $q(this).addClass("active-sample");
});

$q('.card__quick-add button.btn.btn--secondary.button-sample').on("mousedown", function(event){

    event.stopPropagation();
    //console.log('this', this);
    //console.log('event.target',event.target);
    $q(".active-sample").removeClass("active-sample");
    $q(this).addClass("active-sample");
});

// listen for GET cart.json
let removedLineItemVariantId = "";
function listenForFetchCartChange(method,urlPart){

    // Save original fetch
    const originalFetch = window.fetch;
    // Override fetch
    window.fetch = async function (input, init = {}) {

        // Convert Request or string into a URL string
        const url = typeof input === 'string' ? input : input.url;
        // Check for GET or POST + /cart/change
        const isCartJson = url.includes(urlPart) &&  (!init.method || init.method.toUpperCase() === method);
        if (isCartJson) {
            //console.log("[Intercept] " + method + " " + urlPart + " →", url);
            // You can now run custom logic here
            // await doSomething();
            //console.log("do something remove from cart"); 
        }
        // Continue the normal fetch
        const response = await originalFetch(input, init);
        // Optionally inspect the response
        if (isCartJson) {
            try {
                const cloned = response.clone();
                const data = await cloned.json();
                //console.log("[Intercept] " + urlPart + " response:", data);
            } catch (e) {}
        }
        return response;
    };
    async function onCartFetched(cart) {
        removedLineItemVariantId = cart.items_removed[0].variant_id;
        //console.log('Cart item removed / updated:', cart);
        //console.log('Item removal initiated:', removedLineItemVariantId);
        productSampleProductButtonCartCheck(removedLineItemVariantId);
    }
    window.fetch = async function (input, init = {}) {

        const url = typeof input === 'string' ? input : input.url;
        const isCartJson = url.includes(urlPart) && (!init.method || init.method.toUpperCase() === method);
        const res = await originalFetch(input, init);
        if (isCartJson) {
            const data = await res.clone().json();
            onCartFetched(data);
        }
        return res;
    };
}
if(enableCardSampleButtonAjax == true){
    listenForFetchCartChange('POST','/cart/change');
}

// on products card, sets sample button text and disabled state if sample product or sample button 
function productSampleProductButtonCartCheck(variantID) {

    if(enableCardSampleButtonAjax == true){

        setTimeout(function(){

            //console.log('variantID 0',variantID);

            if(document.querySelector("html.is-products") !== null || document.querySelector("html.is-collections") !== null || document.querySelector("html.search") !== null || document.querySelector("html.is-home") !== null || document.querySelector("html.is-pages") !== null){
        
                let activeSampleButton;
                if(document.querySelector(".card button.btn.btn--primary.has-sample.active-sample") != null){
                    activeSampleButton = document.querySelector(".card button.btn.btn--primary.has-sample.active-sample");
                }
                if(document.querySelector(".card button.btn.btn--secondary.button-sample.active-sample") != null){
                    activeSampleButton = document.querySelector(".card button.btn.btn--secondary.button-sample.active-sample");
                }
                //console.log('activeSampleButton 1',activeSampleButton);
                if(typeof variantID !== "undefined"){
                    activeSampleButton = document.querySelector('.card button[data-variant-id="' + variantID + '"]');
                    //console.log('activeSampleButton reset from variantID',activeSampleButton);
                }
                //console.log('activeSampleButton 2',activeSampleButton);
                if(activeSampleButton !== null && typeof activeSampleButton !== "undefined") {

                    //console.log('activeSampleButton 3',activeSampleButton);
                    let sampleFormBox = activeSampleButton.closest("form.js-product-form");//.card__quick-add 
                    //console.log('sampleFormBox 1',sampleFormBox);
                    if(sampleFormBox !== null){

                        //console.log('sampleFormBox 2',sampleFormBox);

                        let sampleButton = activeSampleButton;//sampleFormBox?.querySelector("button.btn.btn--primary.has-sample.active-sample");
                        if(sampleButton !== null){
                        
                            //console.log('sampleButton',sampleButton);

                            let sampleVariantID = activeSampleButton.dataset.variantId;//sampleFormBox.closest("product-form").dataset.variantId;
                            //console.log('sampleVariantID 0',sampleVariantID);
                            if(typeof variantID !== "undefined"){
                                sampleVariantID = variantID;
                                //console.log('variantID 1',variantID);
                                // console.log('sampleVariantID 1',sampleVariantID);
                            }
                            let hasSampleInCart = false;
                            let sampleCountLimit = false;
                            let samplePrice = sampleButton.dataset.samplePrice;
                            //console.log('samplePrice',samplePrice);
                            let sampleButtonText = "Add " + samplePrice + " Sample";
                            let sampleCount = 0;
                            for (var cartItem of document.querySelectorAll("#cart-items tr.cart-item")) {
                                // data-variant-id="46251452170462"
                                let productTitle = cartItem.querySelector('.cart-item__title').textContent;
                                if(productTitle.indexOf("Sample of") != -1){
                                    sampleCount++;
                                }
                                let variantID = cartItem.dataset.variantId;
                                if(sampleVariantID == variantID){
                                    hasSampleInCart = true;
                                    sampleButtonText = "Sample in Cart";
                                }
                                if(sampleCount == 10){
                                    sampleCountLimit = true;
                                }
                            }
                            //console.log("sampleCount",sampleCount);
                            //console.log("sampleCountLimit",sampleCountLimit);
                        
                            if(hasSampleInCart == true){
                                sampleButton.setAttribute("disabled",true);
                            } else {
                                sampleButton.removeAttribute("disabled");
                            }

                            //if (sampleCountLimit == true){
                                //sampleButtonText = "Max Sample Cart Limit";
                                //sampleButton.setAttribute("disabled",true);
                            //}
                            
                            sampleButton.textContent = sampleButtonText;
                            $q(sampleButton).removeClass('actve-sample');
                        }
                    }
                }
            }

        }, 1350);
    
    }
}

/* function resetSampleProductAfterRemoveFromCart() {

  setTimeout(function(){
  
    for (var activeSampleButton of document.querySelectorAll("button.btn.btn--primary.has-sample.active-sample")) {

        let sampleFormBox = activeSampleButton.closest(".card__quick-add form.js-product-form");
        if(sampleFormBox !== null && (document.querySelector("html.is-products") !== null || document.querySelector("html.is-collections") !== null || document.querySelector("html.search") !== null || document.querySelector("html.is-home") !== null)){
        
            let sampleButton = sampleFormBox.querySelector("button.btn.btn--primary.has-sample.active-sample");
            //console.log('sampleButton',sampleButton);
            let sampleVariantID = sampleFormBox.closest("product-form").dataset.variantId;
            let hasSampleInCart = false;
            //let sampleCountLimit = false;
            let samplePrice = sampleButton.dataset.samplePrice;
            //console.log('samplePrice',samplePrice);
            let sampleButtonText = "Add " + samplePrice + " Sample";
            let sampleCount = 0;
            for (var cartItem of document.querySelectorAll("#cart-items tr.cart-item")) {
                // data-variant-id="46251452170462"
                let productTitle = cartItem.querySelector('.cart-item__title').textContent;
                if(productTitle.indexOf("Sample of") != -1){
                    sampleCount++;
                }
                let variantID = cartItem.dataset.variantId;
                if(sampleVariantID != variantID){
                    hasSampleInCart = false;
                }
            }
            //console.log("sampleCount",sampleCount);
            //console.log("sampleCountLimit",sampleCountLimit);
        
            if(hasSampleInCart == false){
                sampleButton.removeAttribute("disabled");
                sampleButton.textContent = sampleButtonText;
            }
            
            sampleButton.textContent = sampleButtonText;
        }
    }

  }, 1000);
} */

function sampleProductCartCheck(t){

  setTimeout(function(){

    //console.log("t",t);
    //console.log("sampleProductCartCheck",sampleProductCartCheck);

    let sampleProductFormBox = document.querySelector("html.is-products.is-sample-product product-form form.js-product-form.js-product-form-main");
    if(sampleProductFormBox !== null && document.querySelector("html.is-products.is-sample-product") !== null){
      
        // js-product-form

    	let sampleButton = sampleProductFormBox.querySelector(".product-info__add-to-cart .product-info__add-button .btn.btn--primary");
    	let sampleVariantID = sampleProductFormBox.querySelector('input[type="hidden"][name="id"]').value;
        //console.log("sampleVariantID",sampleVariantID);
    	let hasSampleInCart = false;
        let sampleCountLimit = false;
    	let samplePrice = sampleButton.dataset.samplePrice;
    	let sampleButtonText = "Add " + samplePrice + " Sample";
        let sampleCount = 0;
    	for (var cartItem of document.querySelectorAll("#cart-items tr.cart-item")) {
        	// data-variant-id="46251452170462"
            let productTitle = cartItem.querySelector('.cart-item__title').textContent;
            if(productTitle.indexOf("Sample of") != -1){
              sampleCount++;
            }
        	let variantID = cartItem.dataset.variantId;
    		if(sampleVariantID == variantID){
    			hasSampleInCart = true;
    			sampleButtonText = "Sample in Cart";
    		}
            if(sampleCount == 10){
              sampleCountLimit = true;
            }
    	}
        //console.log("sampleCount",sampleCount);
        //console.log("sampleCountLimit",sampleCountLimit);
        //console.log("hasSampleInCart",hasSampleInCart);
    
    	if(hasSampleInCart == true){
    		sampleButton.setAttribute("disabled",true);
    	} else {
    		sampleButton.removeAttribute("disabled");
    	}

        if(sampleCountLimit == true){
          sampleButtonText = "Max Limit of 10 Samples in Cart";
          sampleButton.setAttribute("disabled",true);
        }
          
    	sampleButton.textContent = sampleButtonText;  
    }

  }, 1000);
}

if(document.querySelector("html.is-products.is-sample-product") !== null){
    document.querySelector("html.is-products.is-sample-product form.js-product-form.js-product-form-main .product-info__add-to-cart .btn.btn--primary").setAttribute("disabled",true);
    sampleProductCartCheck();
}

//if(document.querySelector("html.is-products") !== null || document.querySelector("html.is-collections") !== null || document.querySelector("html.search") !== null || document.querySelector("html.is-home") !== null) {
    //sampleButtonCartCheck();
    //productSampleProductButtonCartCheck();
//}

//waitForElm('html.is-products form.js-product-form.js-product-form-main [name="id"]', true).then((elm) => {
  //var variantID = document.querySelector('html.is-products form.js-product-form.js-product-form-main [name="id"]').value;
  //console.log("variantID: ",variantID);
//});

////////////////////////////////////////////////////////////////
// mediaCheck - https://github.com/sparkbox/mediaCheck/blob/main/src/mediaCheck.js
function mediaCheck(options) {
    if (typeof window.matchMedia === 'undefined' || !window.matchMedia('!').addListener) { throw new Error('No matchMedia support'); }

    function mqChange(mq, options) { if (mq.matches) { if (typeof options.entry === 'function') { options.entry(mq); } } else { if (typeof options.exit === 'function') { options.exit(mq); } } if (typeof options.both === 'function') { options.both(mq); } }

    function createListener() {
        let mq = window.matchMedia(options.media);
        mq.addListener(function() { mqChange(mq, options); });
        window.addEventListener('orientationchange', function() {
            mq = window.matchMedia(options.media);
            mqChange(mq, options);
        }, false);
        mqChange(mq, options);
    }
    createListener();
}

// only run if product page
if (document.querySelector("html.is-products") !== null) {

    ////////////////////////////////////////////////////////////////
    // add product-info__block helper class identifier'

    // wait and listen for element exists in DOM to work with
    for (var colorways of document.querySelectorAll(".colorways-related-product-swatches.collection-products")) {
        //colorways = document.querySelector(".colorways-related-product-swatches");
        //colorways.closest(".product-info__block").classList.add("has-colorways");
        $q(colorways.closest(".product-info__block")).addClass("has-colorways");
    }
    if(document.querySelector("html.is-products .has-colorways") !== null && document.querySelector("html.is-products .has-colorways .colorways-related-product-swatches ul li") === null){
        document.querySelector(".has-colorways").style.display = "none";
    }

    for (var relatedWidths of document.querySelectorAll(".related-fabric-widths.collection-products")) {
        $q(relatedWidths.closest(".product-info__block")).addClass("has-related-widths");
    }
    for (var outOfStock of document.querySelectorAll(".product-info .out-of-stock-disco")) {
        $q(document.documentElement).addClass("is-out-of-stock");
    }
    for (var customAccordion of document.querySelectorAll(".product-info .custom-accordion")) {
        let accordionType = customAccordion.dataset.accordionType;
        //console.log(accordionType);
        if (accordionType === "cleaning-care" || accordionType === "warranty" || accordionType === "delivery-shipping" || accordionType === "boxcushion") {
            //customAccordion.closest(".product-info__block").classList.add("has-"+accordionType);
            $q(customAccordion.closest(".product-info__block")).addClass("has-" + accordionType);
        }
    }
    // product label (NOT product page)
    for (var catCustomProductThemeLabel of document.querySelectorAll("product-card .product-label-container .product-label.product-label--custom")) {
        $q(catCustomProductThemeLabel.closest(".card__media")).addClass("has-custom-product-theme-label");
        $q(catCustomProductThemeLabel.parentElement).addClass("parent-of-custom-product-theme-label");
        //catCustomProductThemeLabel.closest(".product-label-container").style.display = "none";
    }
    // // product label (ONLY product page) - only loop through first variant product label
    for (var customProductThemeLabel of document.querySelectorAll(".product-info > variant-label.product-info__block .variant-label.js-variant-label:first-child .product-label.product-label--custom")) {
        // product-label--sale  --  .product-label-container
        if (customProductThemeLabel.closest("variant-label.product-info__block").querySelector(".product-label product-label--sale") !== null) {
            customProductThemeLabel.style.display = "none";
        } else {
            customProductThemeLabel.closest("variant-label.product-info__block").style.display = "none";
        }
    }
    // add has images class if megamenu uses image collection for submenu nav image 
    for (var megaMenu of document.querySelectorAll("main-menu.main-menu ul.main-nav .main-nav__child.mega-nav.mega-nav--sidebar.has-motion")) {
        if (megaMenu.querySelector(".main-nav__grandchild li a div.media img") !== null) {
            $q(megaMenu).addClass("has-menu-images");
        }
    }

    for (var relatedWidths of document.querySelectorAll("html.is-products #paypalCreditBadge")) {
        $q(relatedWidths.closest(".product-info__block")).addClass("has-paypal-credit");
    }


    // hide empty description
    if (enablehideEmptyDescription === true) {

        $q(document.documentElement).addClass("hide-empty-description");
        for (var descriptionContent of document.querySelectorAll(".disclosure__content.product-description")) {
            //console.log(descriptionContent.innerHTML.length);
            if (descriptionContent.textContent.trim().length > 0) {/* descriptionContent.innerHTML.length > 1 */
                $q(descriptionContent.closest("details-disclosure")).addClass("show-description");
                //$q(descriptionContent.closest("details-disclosure")).addClass(, "hide-description");
            }
        }
    } else {
        $q(document.documentElement).addClass("show-empty-description");
    }

    // add has-custom-options class to product-info__block
    if (document.querySelector(".product.js-product .product-info__block.product-options") !== null) {
        $q(document.documentElement).addClass("has-custom-options");
    }
    // add has-application class to product-info__block
    for (var application of document.querySelectorAll(".product.js-product .product-info__block #application-icons-box")) {//#application-list
        $q(application.closest(".product-info__block")).addClass("has-application");
    }
    // add has-kit class to product-info__block
    for (var application of document.querySelectorAll(".product.js-product .product-info__block #kit-list")) {
        $q(application.closest(".product-info__block")).addClass("has-kit");
    }
    // add has-minmaxify class to product-info__block
    for (var application of document.querySelectorAll(".product.js-product .product-info__block .minmaxify-product-limits")) {
        $q(application.closest(".product-info__block")).addClass("has-minmaxify");
    }
    // add has-review class to product-info__block
    //waitForElm('.product.js-product .product-info__block .yotpo-widget-instance', true).then((elm) => {
    $q('.product.js-product .product-info__block .yotpo-widget-instance').wait(true,(elm) => {
        $q(document.querySelector(".product-info__block .yotpo-widget-instance").closest(".product-info__block")).addClass("has-review");
    });
    // hide empty product backorder
    if (document.querySelector('.product-info__block.product-backorder [hidden=""].backorder') !== null) {
        document.querySelector('.product-info__block.product-backorder').style.display = "none";
    }

    //waitForElm('div[id*="__discount_depot_volume_table_"]', true).then((elm) => {
    $q('div[id*="__discount_depot_volume_table_"]').wait(true,(elm) => {
        if (document.querySelector('div[id*="__discount_depot_volume_table_"]') !== null) {
            let productInfoBlockVolumeTable = document.querySelector('div[id*="__discount_depot_volume_table_"]').closest(".product-info__block");
            $q(productInfoBlockVolumeTable).addClass("has-volume-table");
            if (document.querySelector('div[id*="__discount_depot_volume_table_"] p[style="display:none"]') !== null) {
                productInfoBlockVolumeTable.style.display = "none"
            }
        }
    });
}

////////////////////////////////////////////////////////////////
// cross browser and cross device helper classes - window.navigator.userAgent.match(/Safari/i) == "Safari";
var winNav = window.navigator;
var UA = winNav.userAgent;
var isSafari = UA.match(/Safari/i) == "Safari";
var isMac = UA.match(/Macintosh/i) == "Macintosh";
var isTouchIpad = (UA.match(/iPad/i) == "iPad");
var isTouchIphone = (UA.match(/iPhone/i) == "iPhone");
var isTouch = window.matchMedia('(pointer: coarse)').matches;//'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;//(!!("undefined" != typeof document.documentElement.ontouchstart)) || (winNav.maxTouchPoints > 0);
var isFirefox = UA.match(/Firefox/i) == "Firefox";
var isChrome = UA.match(/Chrome/i) == "Chrome";
var isChromium = window.chrome;
var vendorName = winNav.vendor;
var isOpera = typeof window.opr !== "undefined";
var isIEedge = UA.indexOf("Edge") > -1;
var isIOSChrome = UA.match("CriOS");
var browserVersion = UA.match(/Version\/(.*)$/);
var html = document.documentElement;

function setBrowserHelperClasses() {

    if (isSafari) {
        $q(html).addClass("is-safari");
    }
    if (browserVersion !== null) {
        var isSafari13 = (isSafari && browserVersion[0].indexOf("13") !== -1);
        if (isSafari13) {
            $q(html).addClass("safari-13");
        }
    }
    if (isMac) {
        $q(html).addClass("is-mac");
    }
    if (isTouchIpad) {
        $q(html).addClass("is-ipad");
    }
    if (isTouchIphone) {
        $q(html).addClass("is-iphone");
    }
    if (isFirefox) {
        $q(html).addClass("is-firefox");
    }
    // Check if google chrome
    if (isIOSChrome) {
        // is Google Chrome on IOS
        $q(html).addClass("is-chrome-ios");
    } else if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
        // is Google Chrome 
        $q(html).addClass("is-chrome");
    } else {
        // not Google Chrome
        $q(html).addClass("not-chrome");
    }
}
setBrowserHelperClasses();

function touchClass() {

    if (isTouch === true) {
        $q(html).removeClass("touch-no");
        $q(html).addClass("touch");
        if (isTouchIpad == true) {
            $q(html).addClass("touch-ipad");
        } else {
            $q(html).removeClass("touch-ipad");
        }
        var nua = navigator.userAgent
        var isSilkBrowser = UA.indexOf("Silk") !== -1;
        if (isSilkBrowser) {
            $q(html).addClass("silk");
        } else {
            $q(html).removeClass(html, "silk");
        }
    } else {
        $q(html).removeClass("touch");
        $q(html).addClass("touch-no");
    }
}
touchClass();

/////////////////////////////////////////////
// check orientation
function checkOrientation(isMobile) {

    //alert(navigator.userAgent);
    if (isMobile) {
        if (window.matchMedia("(orientation: landscape)").matches) {
            $q(html).removeClass("portrait");
            $q(html).addClass("landscape");
        } else if (window.matchMedia("(orientation: portrait)").matches) {
            $q(html).removeClass("landscape");
            $q(html).addClass("portrait");
        }
    }
}

/////////////////////////////////////////////
// how to use mediaCheck method
mediaCheck({
    media: '(min-width: 769px)',
    // Switch to Desktop Version
    entry: function() {
        // The function that toggles page elements from desktop to mobile mode is called here
        $q(html).removeClass("mobile");
        $q(html).addClass("desktop");
        touchClass();
        checkOrientation(false);
        if(document.querySelector("html.is-products .product-info__block.has-colorways") !== null) {
          if(document.querySelector("html.is-products .has-colorways .disclosure.disclosure--row").hasAttribute("open") == false) {
            // disclosure disclosure--row
            document.querySelector("html.is-products .has-colorways .disclosure.disclosure--row").setAttribute("open","");
          }
        }
        //console.log("mediaCheck: (min-width: 768px) - entry");
    },
    // Switch to Mobile Version
    exit: function() {
        // The function that toggles page elements from mobile to desktop mode is called here
        $q(html).removeClass("desktop");
        $q(html).addClass("mobile");
        touchClass();
        checkOrientation(true);
        if(document.querySelector("html.is-products .product-info__block.has-colorways") !== null) {
          if(document.querySelector("html.is-products .product-info__block.has-colorways .disclosure.disclosure--row").hasAttribute("open")) {
            // disclosure disclosure--row
            document.querySelector("html.is-products .product-info__block.has-colorways .disclosure.disclosure--row").removeAttribute("open");
          }
        }
       // on mobile close description and specs product details disclosure row if open on load 
        if(document.querySelector("html.is-products") !== null) {
          for (var productDetailsDisclosureRow of document.querySelectorAll("html.is-products .product-details .disclosure.disclosure--row")) {
            if(productDetailsDisclosureRow.hasAttribute("open")) {
                productDetailsDisclosureRow.removeAttribute("open");
            }
          }
        }
        //console.log("mediaCheck: (min-width: 768px) - exit");
    }
});

/*let mql = window.matchMedia("(min-width: 768px)");
if(mql.matches){
  
} else {
  
}*/

////////////////////////////////////////////////////////////////
// get shopify handle and add as data attriute on html tag
function addHandleHelperClass() {

    if (document.querySelector("html.page-class-set") === null) {
        const url = new URL(window.location.href); //window.location.pathname;
        const getURLpathname = url.pathname;
        if (getURLpathname.indexOf("/collections/") !== -1 && getURLpathname.indexOf("/products/") === -1) {
            $q(document.documentElement).addClass("is-collections");
        } else if (getURLpathname.indexOf("/products/") !== -1) {
            $q(document.documentElement).addClass("is-products");
        } else if (getURLpathname.indexOf("/pages/") !== -1) {
            $q(document.documentElement).addClass("is-pages");
        } else if (getURLpathname.indexOf("/policies/") !== -1) {
            $q(document.documentElement).addClass("is-policies");
        } else if (getURLpathname.indexOf("/cart") !== -1) {
            $q(document.documentElement).addClass("is-cart");
        }
        if (getURLpathname === "\/") {
            $q(document.documentElement).addClass("is-home");
        } else {
            let lastSlash = getURLpathname.lastIndexOf("/");
            let shopifyHandle = getURLpathname.substring(lastSlash + 1);
            $q(document.documentElement).addClass(shopifyHandle);
        }
        //if(window.console) { console.log("html page-class-set via JS"); }
    }
}
addHandleHelperClass();

////////////////////////////////////////////////////////////////
// START - DOM loaded
document.addEventListener("DOMContentLoaded", (event) => {

    //if(window.console) { console.log("DOM fully loaded and parsed"); }

    // only run if product page
    if (document.querySelector("html.is-products") !== null) {

      ////////////////////////////////////////////////////////////////
      // open or close description and specs if desktop vs mobile
      if (enableAutoOpenProductDetails === true) {

          function autoOpenDetailsDisclosureRow(state) {

              if (typeof state == "undefined") {
                  state = "close";
              }

              // details accordion will auto close for 1024px and below
              if (theme.mediaMatches.lg) {
                  // product details (description and specs) - accordion
                  for (var detailsDisclosureRow of document.querySelectorAll(".product-details__block details.disclosure.disclosure--row")) {
                      if (state === "open") {
                          detailsDisclosureRow.setAttribute("open", "");
                      } else if (state === "close") {
                          detailsDisclosureRow.removeAttribute("open");
                      }
                  }
              }

              // related colorways collection - accordion
              // colorways accordion will always stay open for 1024px and below
              for (var hasColorwaysDisclosureRow of document.querySelectorAll(".product-info__block.has-colorways details.disclosure.disclosure--row")) {
                  //if (window.matchMedia("(max-width: 600px)").matches) {
                  if (hasColorwaysDisclosureRow.hasAttribute("open")) {
                      //hasColorwaysDisclosureRow.setAttribute("open","");
                  } else {
                      hasColorwaysDisclosureRow.setAttribute("open", "");
                  }
                  //} else {
                  //if(state === "open"){
                  //hasColorwaysDisclosureRow.setAttribute("open","");
                  //} else if(state === "close"){
                  //hasColorwaysDisclosureRow.removeAttribute("open");
                  //}
                  //}
              }

              /**/
              if(window.matchMedia("(max-width: 768px)").matches){
                if(document.querySelector("html.is-products .product-info__block.has-colorways") !== null) {
                  if(document.querySelector("html.is-products .product-info__block.has-colorways .disclosure.disclosure--row").hasAttribute("open")) {
                      document.querySelector("html.is-products .product-info__block.has-colorways .disclosure.disclosure--row").removeAttribute("open");
                  } else {
                      document.querySelector("html.is-products .has-colorways .disclosure.disclosure--row").setAttribute("open","");
                  }
                }
              }
          }
          //let mql = window.matchMedia("(min-width: 1025px)");
          //if(theme.mediaMatches.lg){//mql.matches
          //autoOpenDetailsDisclosureRow("open");
          //}
          if (theme.mediaMatches.lg) {
              autoOpenDetailsDisclosureRow("open");
          } else {
              autoOpenDetailsDisclosureRow("close");
          }
          //on:debounced-resize
          //on:breakpoint-change
          window.addEventListener('on:breakpoint-change', (event) => {
              //console.log(theme.mediaQueries);
              if (theme.mediaMatches.lg) {
                  autoOpenDetailsDisclosureRow("open");
              } else {
                  autoOpenDetailsDisclosureRow("close");
              }
          });
          /* theme.mediaQueries
          lg: "(min-width: 1024px)"
          md: "(min-width: 769px)"
          portrait: "(orientation: portrait)"
          sm: "(min-width: 600px)"
          xl: "(min-width: 1280px)"
          xxl: "(min-width: 1536px)"*/
      }

      // add unit of measure on product page
      if (enableUnitOfMeasure === true) {
          //waitForElm('.product-info__block.product-price .price__current', true).then((elm) => {
          $q('.product-info__block.product-price .price__current').wait(true,(elm) => {

              if (document.querySelector(".product-info__block.product-price .price__current") !== null) {
                  if (document.querySelector(".product-sku") !== null) {
                      let unitOfMeasure = document.querySelector(".product-sku").dataset.unitOfMeasure;
                      document.querySelector(".product-info__block.product-price .price__current").dataset.unitOfMeasure = unitOfMeasure;
                  }
              }
          });
      }

      // has sample button class
      //waitForElm('.product-info .product-info__add-to-cart .btn--primary', true).then((elm) => {
      $q('.product-info .product-info__add-to-cart .btn--primary').wait(true,(elm) => {

          // adds add to cart parent helper class for sticky - .closest(".product-info__block")
          let hasSampleClass = "";
          if (document.querySelector("button.btn.shopify-payment-button__button-sample") !== null) {
              document.querySelector("button.btn.shopify-payment-button__button-sample").parentElement.parentElement.parentElement.parentElement.classList.add("has-sample-button");
              hasSampleClass = "has-sample-button-sibling";
          }
          if (document.querySelector(".product-info__add-to-cart") !== null) {
              let addToCartButton = document.querySelector(".product-info__add-to-cart");
              addToCartButton.parentElement.parentElement.parentElement.classList.add("has-qty-add-to-cart-button");
              if (hasSampleClass !== "") {
                  addToCartButton.parentElement.parentElement.parentElement.classList.add(hasSampleClass);
              }
          }

          //if(document.querySelector("button.btn.shopify-payment-button__button-sample") !== null){
          // document.querySelector("button.btn.shopify-payment-button__button-sample").parentElement.parentElement.classList.add("has-sample-button");
          //}
      });

      // access shadow root to change font family and color on to shopify-installments-modal eligibility-approval text 
      // since it uses system font making it hard to read
      //waitForElm('html.is-products shopify-installments-modal', true).then((elm) => {
      $q('html.is-products shopify-installments-modal').wait(true,(elm) => {

          // Access the shadow host element
          let shadowHost = document.querySelector('shopify-installments-modal');
          // Access the shadow root
          let shadowRoot = shadowHost.shadowRoot;
          // Select an element within the shadow root
          let eligibilityApprovalShadow = shadowRoot.querySelector('#eligibility-approval');
          eligibilityApprovalShadow.style.fontFamily = "Arial";
          eligibilityApprovalShadow.style.color = "#555555";
      });
      /* //waitForElm('html.is-products shopify-payment-terms', true).then((elm) => {
      $q('html.is-products shopify-payment-terms').wait(true,(elm) => {
        
        // Access the shadow host element
        let shadowHost = document.querySelector('shopify-payment-terms');    
        // Access the shadow root
        let shadowRoot = shadowHost.shadowRoot;
        let shadowRoot2 = shadowRoot.querySelector('shop-pay-installments-banner').shadowRoot
        let shopifyInstallmentsCTA = shadowRoot2.querySelector('#shopify-installments-cta');
        shopifyInstallmentsCTA.style.textDecoration = "none";
      });*/

      /*window.addEventListener("load", (event) => {

          //waitForElm('html product-card .card__media.has-custom-product-theme-label', true).then((elm) => {
          $q('html product-card .card__media.has-custom-product-theme-label').wait(true,(elm) => {
          
            $q(document.documentElement).addClass("custom-product-theme-label-loaded");
          });
      });*/

    }

    // add chevron svg icon to CTA button in header for contuct us dropdown
    /* //waitForElm('header.header__grid .secondary-nav__item.secondary-nav__cta.secondary-nav__cta--button', true).then((elm) => {
    $q('header.header__grid .secondary-nav__item.secondary-nav__cta.secondary-nav__cta--button').wait(true,(elm) => {

        let svgChevronDownIcon = '<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="svg--toggle-icon icon"><path d="M20 8.5 12.5 16 5 8.5" stroke="currentColor" stroke-width="1.5" fill="none"></path></svg>';
        let ctaButton = document.querySelector('header.header__grid .secondary-nav__item.secondary-nav__cta.secondary-nav__cta--button');
        ctaButton.insertAdjacentHTML('beforeend', svgChevronDownIcon);
    });*/

    /////////////////////////////////////////////////
    //  email signup exists message
    //waitForElm('pop-up .modal__window form input[id*="-sign-up"]', true).then((elm) => {
    /*$q('pop-up .modal__window form input[id*="-sign-up"]').wait(true,(elm) => {

        // document.querySelector('pop-up .modal__window form input[id*="__pop_up_"][id*="-sign-up"]')
        // document.querySelector('popup .modal__window form input[id*="-sign-up"]') 
        //if(document.querySelector("pop-up .modal__window form input[id*="__pop_up_"][id*="-sign-up"])){

        //if(window.console){ console.log("pop up"); }

        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        if (urlParams.has("contact_posted") && window.location.href.search("[?&]contact_posted=true") != -1 && window.location.href.search("-sign-up_form") != -1) {

            //if(window.console){console.log("is popup sign up form submitted");}
            if (document.querySelector(".alert.bg-success-bg.text-success-text") !== null) {
                //if(window.console){console.log("popup form success");}
            } else {
                //if(window.console){console.log("popup form NOT success");}
                // add fake message email exists insert into dom
                if (document.querySelector('pop-up .modal__window form input[id*="-sign-up"]').value !== "") {
                    let htmlString = '<div class="alert bg-success-bg text-success-text form__field-error" tabindex="-1" autofocus="">E-mail exists please enter a different email.</div>';
                    document.querySelector("pop-up .modal__window form .form__field").insertAdjacentHTML("afterend", htmlString);
                } else {
                    let htmlString = '<div class="alert bg-success-bg text-success-text form__field-error" tabindex="-1" autofocus="">E-mail exists please enter a different email.</div>';
                    document.querySelector("pop-up .modal__window form .form__field").insertAdjacentHTML("afterend", htmlString);
                }
            }

        } else if (urlParams.has("form_type") && window.location.href.search("[?&]form_type=customer") != -1 && window.location.href.search("-sign-up_form") != -1) {

            //if(window.console){console.log("is popup sign up form submitted");}
            if (document.querySelector(".alert.bg-success-bg.text-success-text") !== null) {
                // if(window.console){console.log("popup form success");}
            } else {
                //if(window.console){console.log("popup form NOT success");}
                // add fake message email exists insert into dom
                if (document.querySelector('pop-up .modal__window form input[id*="-sign-up"]').value !== "") {
                    let htmlString = '<div class="alert bg-success-bg text-success-text form__field-error" tabindex="-1" autofocus="">E-mail exists please enter a different email.</div>';
                    document.querySelector("pop-up .modal__window form .form__field").insertAdjacentHTML("afterend", htmlString);
                } else {
                    let htmlString = '<div class="alert bg-success-bg text-success-text form__field-error" tabindex="-1" autofocus="" >E-mail exists please enter a different email.</div>';
                    document.querySelector("pop-up .modal__window form .form__field").insertAdjacentHTML("afterend", htmlString);
                }
            }
        }
    });*/

    // set request a quote required fields - ?contact_posted=true
    /* //waitForElm('html.boat-canvas-custom-quote .shopify-section.cc-contact-form .form .form__grid > div select[name="contact[year]"] option[selected]', true).then((elm) => {
    $q('html.boat-canvas-custom-quote .shopify-section.cc-contact-form .form .form__grid > div select[name="contact[year]"] option[selected]').wait(true,(elm) => {
      
      if(document.querySelector("html.boat-canvas-custom-quote") !== null){
          for (var quotefieldDiv of document.querySelectorAll(".shopify-section.cc-contact-form .form .form__grid > div")) {
            let quoteFieldDivLabel = quotefieldDiv.querySelector("label").textContent.toLowerCase();
            let quoteField = quotefieldDiv.querySelector(".input");
            if(quoteField.tagName === 'SELECT'){
              if(quoteFieldDivLabel.indexOf("manufacturer") !== -1){
                createOptionSetRequired(quoteField,quotefieldDiv);
              } else if(quoteFieldDivLabel.indexOf("year") !== -1){
                createOptionSetRequired(quoteField,quotefieldDiv);
              } else if(quoteFieldDivLabel.indexOf("products in your quote") !== -1){
                createOptionSetRequired(quoteField,quotefieldDiv);
              }
            } else if(quoteField.tagName === 'INPUT'){
              if(quoteFieldDivLabel.indexOf("model") !== -1){
                $q(quotefieldDiv).addClass("is-required");
                quoteField.setAttribute("required",""); 
              }
            }
          }
      }
    });*/


    ///////////////////////////////////////////
    // copy sku text to clipboard

    // select all text for copy to clipboard
    function selectAllForCopy(obj) {

        var text_val = eval(obj);
        text_val.focus();
        text_val.select();
    }

    ///////////////////////////////////////////
    // copy coupon text to clipboard

    function copyShareLinkClipboardAllPages(id) {

        // Get the text field
        var copyText = document.getElementById(id);

        // Select the text field
        copyText.select();
        // Copy the text inside the text field
        document.execCommand("copy");
        // Alert the copied text
        //console.log("Copied the text: " + copyText.value);
    }

    for (var couponLinkInputButton of document.querySelectorAll(".coupon-link-input-button")) {

      // coupon overlay text input
      // copy share-link to clipboard event
      couponLinkInputButton.addEventListener("click",function(e){

          e.preventDefault();
          //console.log("sku-link trigger");

          var selectedItem = this;
          var prevInputID = selectedItem.previousElementSibling.id;
          //console.log(prevInputID);
          copyShareLinkClipboardAllPages(prevInputID);
          $q(selectedItem).addClass("copied");
          setTimeout(function() {
              $q(selectedItem).removeClass("copied");
          }, 1500);

          return false;
      });
    }

    for (var couponLinkInput of document.querySelectorAll(".coupon-link-input")) {
      
      // select all coupon link input[text]
      couponLinkInput.addEventListener("click",function(e){

          e.preventDefault();
          selectAllForCopy(this);
          return false;
      });
    }    
    // END - copy coupon text to clipboard
    //////////////////////////////////////////


  //////////////////////////////////////////////////////////////////////////////////////////
  // fix theme product types not working in chrome
  //waitForElm('#search-bar #product_types #product_types-button', true).then((elm) => {
  $q('#search-bar #product_types #product_types-button').wait(true,(elm) => {
    
    //console.log("search dropdown exists");
    
    document.querySelector("#search-bar #product_types #product_types-button").addEventListener("click", function(){
      //console.log("search dropdown clicked");
      let productTypesListBox = document.querySelector("#search-bar #product_types ul.custom-select__listbox");
      this.setAttribute("aria-expanded", "true");
      productTypesListBox.setAttribute("aria-hidden", "false");
      productTypesListBox.removeAttribute("hidden");
    });

    var urlString = window.location.search;
    var urlParams = new URLSearchParams(urlString);
    var filterParamValue = urlParams.get('filter.p.product_type');
    var hasSearchProductTypesSearchParam = false;
    var productTypesHiddenInput = document.querySelector("#product_type_input").value;
    if (urlParams.has('filter.p.product_type')) {
        hasSearchProductTypesSearchParam = true;
    }

    let dataValuePT = "";
    for (var productTypeLi of document.querySelectorAll("#search-bar #product_types ul.custom-select__listbox li")) {
      
      productTypeLi.addEventListener("mouseover", function(){
        //console.log("search dropdown clicked");
        $q(this.parentElement.querySelectorAll("li")).removeClass("is-focused");
        $q(this).addClass("is-focused");
      });

      productTypeLi.addEventListener("click", function(){
        //console.log("search dropdown clicked");
        let li = this;
        let dataValue = this.dataset.value;
        //let a = li.querySelector("a");        
        document.querySelector("#product_type_input").value = dataValue;
        //document.querySelector("store-header header").dispatchEvent(new Event("click"));
        let productTypesListBox = document.querySelector("#search-bar #product_types ul.custom-select__listbox");
		    document.querySelector('#product_types #product_types-button').setAttribute("aria-expanded", "false");
        productTypesListBox.setAttribute("aria-hidden", "true");
        productTypesListBox.setAttribute("hidden","");

        for (var ptLI of document.querySelectorAll("#search-bar #product_types ul.custom-select__listbox li")) {
            ptLI.removeAttribute("aria-selected");
        }
        this.setAttribute("aria-selected","true");
        if(dataValue === "") {
          dataValue = "All";
        }
        document.querySelector("#product_types-button span").textContent = dataValue;
      });

      /*if (hasSearchProductTypesSearchParam == true) {
        var dataValue = productTypeLi.dataset.value;
        dataValue.replaceAll("+"," ");
        productTypesHiddenInput.replaceAll("+"," ");        
        if(filterParamValue == dataValue){
          dataValuePT = dataValue;
          //console.log("filterParamValue",filterParamValue);
          //console.log("dataValue",dataValue);
          //console.log("productTypesHiddenInput",productTypesHiddenInput);
         }
      }*/
    }

    //if (hasSearchProductTypesSearchParam == true && dataValuePT !== "") {// filterParamValue
       //document.querySelector('#search-bar #product_types ul.custom-select__listbox li[data-value="' + dataValuePT + '"]').dispatchEvent(new Event("click"));
    //}
    if (hasSearchProductTypesSearchParam == true && filterParamValue !== "") {
      $q(document.documentElement).addClass("has-url-param-product-type-not-empty");
    }

    // close custom select if click outside it
	document.addEventListener("click", function(event) {

    	let targetElement = event.target; // Clicked element
		let customSelect = document.querySelector('#search-bar custom-select.search__product-types');
		if (customSelect && !customSelect.contains(targetElement)) {
            let productTypesListBox = document.querySelector("#search-bar #product_types ul.custom-select__listbox");
			document.querySelector('#product_types #product_types-button').setAttribute("aria-expanded", "false");
            productTypesListBox.setAttribute("aria-hidden", "true");
            productTypesListBox.setAttribute("hidden","");
		}
	});
  });
  

  /////////////////////////////////////////////////////
  // top panel header - company info flyout - hover in
  const trigger = document.querySelector('.top-header-panel-links-info');
  const menu = document.querySelector('.from-admin-menu.top-header-panel-links-info-menu');
  if (trigger && menu) {
    function positionMenu() {
        const rect = trigger.getBoundingClientRect();
        menu.style.left = rect.left + 'px';
        menu.style.top = rect.bottom + 'px';
    }

    trigger.addEventListener('mouseenter', () => {
        positionMenu();
        menu.classList.add('is-open');
    });

    trigger.addEventListener('mouseleave', () => {
        setTimeout(() => {
        if (!menu.matches(':hover')) menu.classList.remove('is-open');
        }, 50);
    });

    menu.addEventListener('mouseenter', () => {
        menu.classList.add('is-open');
    });

    menu.addEventListener('mouseleave', () => {
        menu.classList.remove('is-open');
    });

    window.addEventListener('scroll', () => {
        if (menu.classList.contains('is-open')) positionMenu();
    });

    window.addEventListener('resize', () => {
        if (menu.classList.contains('is-open')) positionMenu();
    });
 }

 

  //////////////////////////////////////////
  // trigger fancy box when jquery loaded
  //waitForElm('html.jquery-is-loaded', true).then((elm) => {// #cd-size-tips-box #cd-size-diagram #cd-size-diagram-a.fancybox 
  $q('html.q-is-loaded').wait(true,(elm) => {//.jquery-is-loaded

    // fix stupid klaviyo popup when max-width 768px
    document.addEventListener('click', function(event) {
        if (event.target.closest('.needsclick.klaviyo-close-form') && !event.target.closest('.needsclick.klaviyo-form')) {
            //let mql = window.matchMedia("(max-width: 768px)");
            //if(mql.matches){
              document.body.classList.remove('klaviyo-prevent-body-scrolling');
              document.querySelectorAll('body > div > .needsclick').forEach(function(el) {
                el.style.display = 'none';
              });
            //}
        }
    }); 

    // add page url to brand landing page
    $q('html.is-pages.landing-page-cms .globo-formbuilder .landing-page-url input[type="text"]').wait(true,(elm) => {
        const urlInput = document.querySelector('html.is-pages.landing-page-cms .globo-formbuilder .landing-page-url input[type="text"]');
        if (urlInput) {
            urlInput.value = window.location.href;
        }
    });

    // move current date into cart page title h1
    if(enableCartCSR == true){

        //document.documentElement.classList.add('is-csr');

        /*$q('html.is-cart.is-csr #current-date #current-date-day').wait(true,(elm) => {
            
            if(document.querySelector('#cart-items .cart-empty') == null){            

                document.documentElement.classList.add('use-pretty-print'); 

                //javascript:(function(){document.documentElement.classList.add('is-csr');document.documentElement.classList.add('use-pretty-print');var link=document.createElement('link');link.rel='stylesheet';link.type='text/css';link.href='https://patiolane.myshopify.com/cdn/shop/t/3/assets/theme-base-cart-print.css?v=98858846728832682101776434344&ts='+Date.now();link.media='print';document.head.appendChild(link);})();

                // (function() {
                //  document.documentElement.classList.add('is-csr');
                //  document.documentElement.classList.add('use-pretty-print');
                //  var link = document.createElement('link');
                //  link.rel = 'stylesheet';
                //  link.type = 'text/css';
                //  link.href = 'https://patiolane.myshopify.com/cdn/shop/t/3/assets/theme-base-cart-print.css?v=98858846728832682101776434344&ts=' + Date.now();
                //  link.media = 'print';
                //  document.head.appendChild(link);
                //})();             

                let date = new Date();
                let formattedDate = date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
                let currentTime = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
                //document.querySelector("#current-time").setAttribute("data-time",currentTime);
                $q("#current-time").text(currentTime);
                $q("#current-date-day").text(formattedDate);

                // add print contact iinfo to header
                function csrAddress() {

                    var info = [
                        { 
                            "store": "pl",
                            "numberLocal": "727.498.0547",
                            "numberTollFree": "1.866.516.0934"
                        }// ,
                        //{ 
                        //    "store": "ofc",
                        //    "numberLocal": "727.597.4134",
                        //    "numberTollFree": "1.866.712.5684"
                        //},
                        //{ 
                        //    "store": "ot",
                        //    "numberLocal": "727.597.4141",
                        //    "numberTollFree": "1.866.516.0941"
                        //}
                    ];

                    // which store is currently active
                    var activeStore = "pl";  // example

                    // find matching store object
                    var storeData = info.find(obj => obj.store === activeStore);

                    let html = "";

                    if (storeData) {
                        html = `
                        <div id="print-contact-info" style="display: none;">
                            10820 US 19 North<br>
                            Clearwater, FL 33764 USA<br>
                            Local: ${storeData.numberLocal}<br>
                            Toll-Free: ${storeData.numberTollFree}</p>
                        </div>
                        `;
                        document.querySelector('store-header.header header').insertAdjacentHTML('beforeend', html);
                        //console.log(html);
                    }
                }
                csrAddress();
                $q('#pdf-csr-button').on('click',function(){

                    if($q("#current-date").hasClass('active')){
                        $q("#current-date").removeClass('active');
                    } else {
                        $q("#current-date").addClass('active');
                    }
                });
                $q("#pdf-csr-button").addClass('active');
            }

        });*/
    }

    $q('html.q-is-loaded #main-content div.youtube').wait(true,(elm) => {

      /* Checks if an image URL exists and loads successfully */
      function imageExists(url) {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve(true);   // Image exists and loaded
          img.onerror = () => resolve(false); // Image 404'd or failed to load
          img.src = url;
        });
      }
		
      // create screenshot only for building of youtube video on click
      /* <div class="youtube" data-video-url="q5kExh31ANY" data-custom-src=""><div class="play-button"><br></div></div> */
      var youtube = document.querySelectorAll("div.youtube");
          //console.log(youtube.length);
      if(youtube.length !== 0){

            //console.log("run youtube video build");						
            //var $homepageVideos = document.getElementById("#homepage-videos");
            //$homepageVideos.style.overflow = "hidden";
            //$homepageVideos.style.maxHeight = 220;
            //https://i1.ytimg.com/vi/<insert-youtube-video-id-here>/default.jpg -   default
            //https://i1.ytimg.com/vi/<insert-youtube-video-id-here>/mqdefault.jpg - medium 
            //https://i1.ytimg.com/vi/<insert-youtube-video-id-here>/hqdefault.jpg - high
            //https://i1.ytimg.com/vi/<insert-youtube-video-id-here>/sddefault.jpg - standard
            
            //var isHome;
            var thumbnailName = "hqdefault";
            var youTubePaddingTop = "";
            var youTubeImgTop = "";
              
            //if($("body.cms-home").length > 0 || $("body.blog-cat-view").length > 0 || $("body.cms-page-view").length > 0 || isCategoryPage || isSearchPage) {
              //thumbnailName = "mqdefault";
            //}
            
            for (var i = 0; i < youtube.length; i++) {
                
              //if(youtube[i].classList.contains("featured-vid")){
                thumbnailName = "maxresdefault";//"hqdefault";
                youTubePaddingTop = "56.25%";
                youTubeImgTop = "-20%";
              //}
              
              var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.videoUrl +"/"+thumbnailName+".jpg";	
              var image = new Image();

              //console.log('image exists',imageExists(source));
                
              // only add image if does not exist
              if(youtube[i].getAttribute("data-custom-src") && youtube[i].dataset.customSrc != ""){
                source = youtube[i].dataset.customSrc;
                youtube[i].dataset.customSrc = source;
              }	
              
              if(thumbnailName == "hqdefault"){
                youtube[i].style.paddingTop = youTubePaddingTop;
                image.style.top = youTubeImgTop;
              }
              
              image.src = source;
              
              if (navigator.appName == 'Microsoft Internet Explorer' || (navigator.appName == "Netscape" && navigator.appVersion.indexOf('Edge') > -1)){
                // IE or EDGE
                //image.addEventListener("load", function() {
                  youtube[i].appendChild(image);
                //});
              }  else {
                image.addEventListener("load", function() {
                  youtube[i].appendChild(image);
                }(i));
              }
              
              youtube[i].addEventListener( "click", function() {
                
                var iframe = document.createElement("iframe");
                iframe.setAttribute("width", "100%");
                iframe.setAttribute("height", "100%");
                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("allowfullscreen", "");
                iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
                iframe.setAttribute("src", "https://www.youtube.com/embed/"+ this.dataset.videoUrl +"?autoplay=1");
                //  +"?rel=0&showinfo=0&autoplay=1&hd=1"
                this.innerHTML = "";
                this.appendChild(iframe);
                //this.prepend(iframe);
              });	
            };
      }
	  });

    //console.log('jquery and q loaded');
    //console.log(typeof jQuery.fn.fancybox !== "undefined");
 
    //jonnyZoom('.zoom-origin:not(.tooltip-trigger):not(.preview):not(.simple-modal):not(.default-modal):not(.simple-modal-no-arrows):not(.gallery-modal)', { nav: 'off' }, 'zoomOrigin');
    //jonnyZoom('.zoom-origin.simple-modal', { thumbs: 'off' }, 'zoomOriginSimpleModal');
    //jonnyZoom('.zoom-origin.gallery-modal', { loopMode: 'bounded' }, 'zoomOriginGalleryModal');
    //jonnyZoom('.zoom-origin.simple-modal-no-arrows.modal-has-download:not(.modal-popup)', { nav: 'off', thumbs: 'off' }, 'zoomOrigin');

    // only run on is-builder page]
	  if($q("html.is-builder").length > 0) {

        const jonnyzoomBuilder = jonnyZoom('.cd-builder-ready', { triggerSelector: '.jonnyzoom-builder' });
        const jonnyzoomBuilderMiniFabricPicker = jonnyZoom('body', { triggerSelector: '.jonnyzoom-builder--mini-fabric-picker', loopMode: 'bounded', nav: 'on', thumbs: 'on', thumbsOnTouchHide: false });
        //jonnyZoom('.cd-builder-ready', {  }, 'jonnyzoomBuilder');
        //const jonnyzoomBuilder = jonnyZoom('.cd-builder-ready',{ targetSelector: '.jonnyzoom-builder' });

        const jonnyzoomFabricPicker = jonnyZoom('#fp-slider', { loopMode: 'bounded', nav: 'on', thumbs: 'on', thumbsOnTouchHide: false });// wrap

        const jonnyzoom = jonnyZoom('body', { triggerSelector: '.jonnyzoom-popover', loopMode: 'bounded', nav: 'on', thumbs: 'off', thumbsOnTouchHide: false });

        //console.log("html.is-builder");

        // convert fancybox to jonnyZoom
        //jonnyZoom('#gallery1', { thumbs: 'off' }, 'galleryA');
        //jonnyZoom('#gallery2', { loopMode: 'bounded' }, 'galleryB'); 
        
        //jonnyZoom('.jonnyzoom-share-link', { }, 'jonnyZoomShareLink');
        //jonnyZoom('.share-link-internal-summary', { }, 'shareLinkInternalSummary');
        //jonnyZoom('.simple-modal-no-arrows', { }, 'simpleModalNoArrows');
        //jonnyZoom('.gallery-modal-2', { }, 'galleryModal2');

    } else {
        
        const jonnyzoom = jonnyZoom('body',{ triggerSelector: '.jonnyzoom' });
        const jonnyzoomFancybox = jonnyZoom('body',{ triggerSelector: '.fancybox' });

        //jonnyZoom({ triggerSelector: '.jonnyzoom', nav: 'off', thumbs: 'off' }, 'jonnyzoom');    
        //jonnyZoom({ targetSelector: '.jonnyzoom' }, 'jonnyzoomSite');
        //const zoom = jonnyZoom('.jonnyzoom', { });

        // No parent needed, global scan:
        //const zoom = jonnyZoom({ triggerSelector: '.jonnyzoom' });
        // Back-compat name still works:
        //const zoom2 = jonnyZoom({ targetSelector: '.jonnyzoom' });
        // With an explicit parent (still supported):
        //const zoom3 = jonnyZoom('#gallery1', { triggerSelector: 'a[data-zoom]' });
        // or pass global window var
        //jonnyZoom('#gallery1', {  }, 'jonnyzoom');
    }

    /* if(jQuery.fn.fancybox){

        //console.log('fancybox loaded');

					//console.log($q('.fancybox:not(.tooltip-trigger):not(.preview)').length);

					jQuery('.fancybox:not(.tooltip-trigger):not(.preview):not(.simple-modal):not(.default-modal):not(.simple-modal-no-arrows):not(.gallery-modal)').fancybox({
					    //animationEffect: "zoom",
						//transitionEffect: "zoom-in-out",
						//protect: true,
						////loop: true,
						//caption: function (instance, item) {
							////console.log($q(this).attr("title"));
							//var title = $q(this).attr("title");
							////	if ($q(this).next('figcaption').length > 0) {
							////		title = $q(this).next('figcaption').html();
							////	}
							//return title;
						//},
						//image: {
						//	preload: true
						//}
                        clickSlide: "close",
                        clickOutside: "close",
                        hash: false,
						buttons: [
							//"zoom",
							//"share",
							//"slideShow",
							//"fullScreen",
							//"download",
							"thumbs",
							"close"
						],
						thumbs: {
							autoStart: true, // Display thumbnails on opening
							hideOnClose: false, // Hide thumbnail grid when closing animation starts
							//parentEl: ".fancybox-container", // Container is injected into this element
							axis: "y" // Vertical (y) or horizontal (x) scrolling
						},
						autoFocus: false,
						afterShow: function(){
							$q("html").addClass("fancybox-open");
						},
						afterClose: function(){
							$q("html").removeClass("fancybox-open");
						}
					});

				    ///* jQuery().fancybox({
					//	selector : '.fancybox:not(.tooltip-trigger):not(.preview):not(.simple-modal)',
					//	parentEl: "#main-content",
					//	autoFocus: false,
                    //    hash: false,
					//});


					jQuery().fancybox({
						selector : '.fancybox.simple-modal',
						parentEl: "#main-content",
						arrows: true,
						toolbar: true,
						vertical: false,
						loop: false,
						autoFocus: false,
                        hash: false,
                        clickSlide: "close",
                        clickOutside: "close",
						buttons: [
							//"zoom",
							//"share",
							//"slideShow",
							//"fullScreen",
							//"download",
							//"thumbs",
							"close"
						], 
						beforeShow: function(){
							jQuery("html").addClass("simple-modal");
						},
						beforeClose: function(){
							jQuery("html").removeClass("simple-modal");
						}
					});


					jQuery().fancybox({
						selector : '.fancybox.gallery-modal',
						parentEl: "#main-content",
						arrows: true,
						toolbar: true,
						vertical: false,
						loop: false,
						autoFocus: false,
                        hash: false,
                        clickSlide: "close",
                        clickOutside: "close",
						thumbs: {
							autoStart: false, // Display thumbnails on opening
							hideOnClose: true, // Hide thumbnail grid when closing animation starts
							//parentEl: ".fancybox-container", // Container is injected into this element
							axis: "y" // Vertical (y) or horizontal (x) scrolling
						},
						buttons: [
							//"zoom",
							//"share",
							//"slideShow",
							//"fullScreen",
							//"download",
							"thumbs",
							"close"
						], 
						beforeShow: function(){
							$q("html").addClass("gallery-modal");
						},
						beforeClose: function(){
							$q("html").removeClass("gallery-modal");
						},
						afterClose: function(){

						},
					});

					jQuery().fancybox({
						selector : '.fancybox.simple-modal-no-arrows.modal-has-download:not(.modal-popup)',
						parentEl: "#main-content",
						arrows: false,
						toolbar: true,
						vertical: false,
						loop: false,
						autoFocus: false,
						groupAttr: false,
                        hash: false,
						touch: false,//hasTouch,
                        clickSlide: "close",
                        clickOutside: "close",
						buttons: [
							//"zoom",
							//"share",
							//"slideShow",
							//"fullScreen",
							//"thumbs",
							//"download",
							"close"
						],
						beforeShow: function(){
							$q("html").addClass("simple-modal-no-arrows");
						},
						beforeClose: function(){
							$q("html").removeClass("simple-modal-no-arrows");
						}
					});

					// jQuery().fancybox({
					//	selector : '.fancybox.default-modal',
					//	parentEl: ".page-wrapper",
					//	arrows: true,
					//	toolbar: true,
					//	vertical: false,
					//	loop: false,
					//	autoFocus: false,
                    //    hash: false,
                    //    clickSlide: "close",
                    //    clickOutside: "close",
					//	buttons: [
					//		//"zoom",
					//		//"share",
					//		//"slideShow",
					//		//"fullScreen",
					//		//"download",
					//		//"thumbs",
					//		"close"
					//	], 
					//	beforeShow: function(){
					//		$q("html").addClass("default-modal");
					//	},
					//	beforeClose: function(){
					//		$q("html").removeClass("default-modal");
					//	}
					//}//); 


					// only run on is-builder page]
					if($q("html.is-builder").length > 0) {

						//jQuery().fancybox({
							//selector : '.fancybox.tooltip-trigger', 
							//type: "inline", 
							//parent: "#pb-box", 
							//arrows: false,
							//toolbar: false,
							//touch: false,
							//vertical: false,
							//autoFocus: false,
							//width: 400,
							//height: 400,
							//maxWidth: "40%",
							//maxHeight: "40%",
                            //hash: false,
                            //clickSlide: "close",
                            //clickOutside: "close",
							//beforeShow: function(){
							//	$q("html").addClass("tooltip-modal");
							//},
							//beforeClose: function(){
							//	$q("html").removeClass("tooltip-modal").addClass("was-tooltip-step-1");
							//}////,
							////baseClass: "fancybox-tooltip"
						//});

                        jQuery().fancybox({
                            selector : '.fancybox-share-link',
                            parentEl: "#main-content",
                            //buttons : ['close'],
                            loop: false,
                            toolbar: false,
                            arrows: false,
                            touch: false,
                            vertical: false,
                            autoFocus: false,
                            hash: false,
                            clickSlide: "close",
                            clickOutside: "close",
                            beforeShow: function(){
                                $q("html").addClass("share-link-open");
                            },
                            afterClose: function() {
                                $q("html").removeClass("share-link-open");
                            }
                        });

					  	jQuery().fancybox({
							selector : '.fancybox-share-link-internal-summary',
							parentEl: "#main-content",
							//buttons : ['close'],
							loop: false,
							toolbar: false,
							arrows: false,
							touch: false,
							vertical: false,
							autoFocus: false,
                            hash: false,
                            clickSlide: "close",
                            clickOutside: "close",
							beforeShow: function(){
								$q("html").addClass("share-link-open");
							},
							afterClose: function() {
								$q("html").removeClass("share-link-open");
							}
						});

						jQuery().fancybox({
							selector : '.fancybox.simple-modal-no-arrows',
							parentEl: "#main-content",
							arrows: false,
							toolbar: true,
							vertical: false,
							loop: false,
							autoFocus: false,
                            hash: false,
                            clickSlide: "close",
                            clickOutside: "close",
							buttons: [
								//"zoom",
								//"share",
								//"slideShow",
								//"fullScreen",
								//"download",
								//"thumbs",
								"close"
							], 
							beforeShow: function(){
								$q("html").addClass("simple-modal-no-arrows");
							},
							beforeClose: function(){
								$q("html").removeClass("simple-modal-no-arrows");
							}
						});

						jQuery().fancybox({
							selector : '.fancybox.gallery-modal-2',
							parentEl: "#main-content",
							arrows: true,
							toolbar: true,
							vertical: false,
							loop: false,
							autoFocus: false,
                            hash: false,
                            clickSlide: "close",
                            clickOutside: "close",
							thumbs: {
								autoStart: false, // Display thumbnails on opening
								hideOnClose: true, // Hide thumbnail grid when closing animation starts
								//parentEl: ".fancybox-container", // Container is injected into this element
								axis: "y" // Vertical (y) or horizontal (x) scrolling
							},
							buttons: [
								//"zoom",
								//"share",
								//"slideShow",
								//"fullScreen",
								//"download",
								"thumbs",
								"close"
							], 
							beforeShow: function(){
								$q("html").addClass("gallery-modal");
								if(document.querySelector("html.desktop") !== null){
									document.querySelector(".fancybox-button.fancybox-button--thumbs").dispatchEvent(new Event("click"));
								}
							},
							beforeClose: function(){
								$q("html").removeClass("gallery-modal");
							},
							afterClose: function(){
								if(document.querySelector("html.desktop .fancybox-show-thumbs") !== null){
									document.querySelector(".fancybox-button.fancybox-button--thumbs").dispatchEvent(new Event("click"));
								}
							},
						});

						// if(jQuery("body.is-builder-pillow").length > 0) {

						//	jQuery().fancybox({
						//		selector : '.fancybox.fancybox-video',
						//		parentEl: "#product-builder",
						//		//buttons : ['close'],
						//		toolbar: false,
						//		arrows: false,
						//		touch: false,
						//		vertical: false,
						//		autoFocus: false,
                        //       hash: false,
						//		afterClose: function() {
						//			$q("#measure-pillow-youtube-video iframe").remove();
						//			$q("#measure-pillow-youtube-video .youtube").append('<div class="play-button"></div><img src="/media/theme/Refueledinc/builders/images/how-to-measure-pillows.jpg">');
						//		}
						//	});
						//} 
					}

      } else {
		//	if(window.console) { console.log("no-fancybox"); }
      } */

    // add blog landing page fabric brand name to form fabric brand name input
    if(document.querySelector('html.blog-cat-landing-page') || document.querySelector('html.blog-post-landing-page')) {

      $q('.globo-formbuilder .ecs-brand-selector input[type="text"]').wait(true,(elm) => { 
          let brandValue = document.querySelector('#blog-brand-value')?.dataset?.brand;
          let input = document.querySelector('.globo-formbuilder .ecs-brand-selector input[type="text"]');
          input.value = brandValue;
          input.dispatchEvent(new Event('change'));
      });
    }
    

  }); // END - q loaded

  ///////////////////////

  $q('td._cd-size--product-type ._cd-size--product-type-maggie input').wait(true,(elm) => { 

    // if swing bed fake builder custom options (non builder)
    if(document.querySelector(".fake-builder.swing-bed-custom") !== null){

      let swingBedType = '';
      let swingBedSize = '';

      if(document.querySelector('html[class*="the-maggie"]')){
        swingBedType = 'size--product-type-maggie';
      } else if(document.querySelector('html[class*="the-shirley"]')){
        swingBedType = 'size--product-type-shirley';
      } else if(document.querySelector('html[class*="the-connie"]')){
        swingBedType = 'size--product-type-connie';
      } else if(document.querySelector('html[class*="the-sophia"]')){
        swingBedType = 'size--product-type-sophia';
      } else if(document.querySelector('html[class*="the-debbie"]')){
        swingBedType = 'size--product-type-debbie';
      }

      if(document.querySelector('html[class*="-crib"]')){
        swingBedSize = 'size--swing-bed-size-crib';
      } else if(document.querySelector('html[class*="-twin"]')){
        swingBedSize = 'size--swing-bed-size-twin';
      } else if(document.querySelector('html[class*="-full"]')){
        swingBedSize = 'size--swing-bed-size-fill';
      }

      //console.log(swingBedType);
      //console.log(swingBedSize);

      //let cdBuilderFake = document.querySelector("#cd-builder-fake");
      let swingBedStyleData = swingBedType;//cdBuilderFake?.dataset?.swingBedStyle;
      let swingBedSizeData = swingBedSize;//cdBuilderFake?.dataset?.swingBedSize;

      //console.log(swingBedStyleData);
      //console.log(swingBedSizeData);

      // auto hide if swing bed style has magento attribute selected
      /* if(swingBedStyleData !== "none"){
        let swingBedStyleElement = document.querySelector("._cd-size--product-type");
        swingBedStyleElement.classList.add("ecs_cd-hide");
        swingBedStyleElement.parentElement.classList.add("hidden");
      }

      // auto hide if swing bed size has magento attribute selected
      if(swingBedSizeData !== "none"){
        let swingBedSizeElement = document.querySelector("._cd-size--swing-bed-size");
        swingBedSizeElement.classList.add("ecs_cd-hide");
        swingBedSizeElement.parentElement.classList.add("hidden");
      } */

      //console.log('td._cd-size--product-type .field.choice._cd-' + swingBedStyleData + ' input');
      //console.log('td._cd-size--swing-bed-size .field.choice._cd-' + swingBedSizeData + ' input');

      // auto select swing bed style and size radio button options
      if(swingBedStyleData !== ""){
        $q('td._cd-size--product-type .field.choice._cd-' + swingBedStyleData + ' input').trigger("click");
      }
      if(swingBedSizeData !== ""){
        $q('td._cd-size--swing-bed-size .field.choice._cd-' + swingBedSizeData + ' input').trigger("click");
      }
    }
  });

  ///////////////////////


  ///////////////////////////////////////////
  // listen and check if jquery is laoded
  let jqueryCheckInterval = setInterval(function() {
    if (typeof jQuery !== 'undefined') {
      //console.log('jQuery is loaded.');
      clearInterval(jqueryCheckInterval);
      $q(document.documentElement).addClass("jquery-is-loaded");
    } else {
      //console.log('jQuery is not yet loaded, checking again...');
    }
  }, 200);

  let queryCheckInterval = setInterval(function() {
    if (typeof querySelector !== 'undefined') {
      //console.log('querySelector is loaded.');
      clearInterval(queryCheckInterval);
      $q(document.documentElement).addClass("q-is-loaded");
    } else {
      //console.log('$q() is not yet loaded, checking again...');
    }
  }, 200);

  // window-loaded
  window.addEventListener("load", function(){
    $q(document.documentElement).addClass("window-loaded");
  });
  
}); // END - DOM loaded